import React, { useMemo } from 'react';
import RateTableRolesDropdown from './RateTableRolesDropdown';
import { getHelperAndTooltip } from './utils';

export const TaskRoleDropdown = props => {
  const propOverrides = useMemo(
    () => ({
      getHelperAndTooltip: ({ intl, selectedRole }) =>
        getHelperAndTooltip({ intl, selectedRole, isTaskRole: true })
    }),
    []
  );

  return <RateTableRolesDropdown {...props} propOverrides={propOverrides} />;
};

export default TaskRoleDropdown;
